// extracted by mini-css-extract-plugin
export var closeButton = "_pn-2";
export var closeButtonIcon = "_pn-3";
export var lightboxContent = "_pn-1";
export var lightboxOverlay = "_pn-0";